<template>
  <div>
    <div class="calendar">
      <div class="calendar__header">
        <CustomHeader
          :color="headerStyles.color"
          :background="headerStyles.background"
          :borderColor="headerStyles.borderColor"
          :icon="isShortVersion ? null : headerIcon"
          text="Calendario"
        />
      </div>
      <div class="calendar__content">
        <div class="main-container is-centered">
          <div class="next-games-container-desktop" :style="{ height: isSecondRow && !getOpened ? '810px' : 'auto' }">
            <!-- League rounds -->
            <template v-if="!loadingFlag">
              <div
                :class="[
                  type === 'only'
                    ? 'next-games-grid-component'
                    : type === 'onlycomponent'
                    ? 'next-games-grid-component-only'
                    : 'next-games-grid',
                  isShortVersion ? 'is-short-version' : '',
                ]"
              >
                <div class="journey bg-gray" style="line-height: 40px;">
                  {{ gamesContainerWidth > 538 ? 'JORNADA' : 'J' }}
                </div>
                <div class="rounds-controller">
                  <div class="rounds-scroll-button left-button is-clickable" @click="onClickScrollLeft">
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn-next-grey.svg" alt="previous" />
                  </div>
                  <div :id="`${id}RC`" ref="roundsContainer" class="next-games-rounds-desktop">
                    <div
                      v-for="n in Object.keys(fullTournamentSchedule)"
                      class="round-item-desktop is-clickable btn-jornada"
                      :class="`${id}${isShortVersion ? '-short-version' : ''}`"
                      :id="`si${n}${id}`"
                      :style="n == selectedRound ? colorItemScroll : ''"
                      :key="n"
                      @click="onClickRound(n)"
                    >
                      {{ n }}
                    </div>
                  </div>
                  <div class="rounds-scroll-button is-clickable" @click="onClickScrollRight">
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn-next-grey.svg" alt="next" />
                  </div>
                </div>
                <div class="round-schedule-container">
                  <div
                    class="games__container"
                    ref="gamesContainer"
                    :style="gridTemplateColumns"
                    :class="{ fallback: gamesContainerWidth === 0 }"
                  >
                    <template v-if="isShortVersion">
                      <div
                        v-if="gamesInRoundDate && gamesInRoundDate.length && gamesInRoundDate[selectedGameIndex]"
                        class="games-carousel"
                      >
                        <BCarousel
                          v-model="selectedGameIndex"
                          :autoplay="false"
                          :indicator-inside="false"
                          :pause-info="false"
                          :progress="false"
                          :arrow="false"
                          :indicator="false"
                          @change="onChangeCarousel"
                        >
                          <BCarouselItem v-for="game of gamesInRoundDate" :key="game.game_id">
                            <CalendarMatch
                              :game="game"
                              :color="headerStyles.color2"
                              :background="headerStyles.background"
                              :backgroundLive="headerStyles.backgroundLive"
                              :team-left="game.home_team"
                              :predictions="predictions"
                              :team-right="game.visiting_team"
                              :time="game.schedule.substring(0, 5)"
                              :date="new Date(game.date)"
                              :is-game-live="!!game.is_live"
                              :game-status="game.game_status"
                              :score="game.score"
                              :percentages="getPercentages(game)"
                              :home-goals="getGoalsStats(game, 'home')"
                              :visiting-goals="getGoalsStats(game, 'visiting')"
                              :containerWidth="gamesContainerWidth"
                              :is-single-game="getOpened"
                              :is-cup="isCup"
                              @action="onGameClicked(game)"
                            />
                          </BCarouselItem>
                        </BCarousel>
                        <div class="games-carousel__arrows">
                          <div
                            role="button"
                            class="arrow left-button"
                            :class="{ 'btn-disabled': isBackDisabled }"
                            @click="onClickChangeGame('back')"
                          >
                            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn-next-grey.svg" alt="previous" />
                          </div>
                          <div class="indicator">{{ selectedGameIndex + 1 }}/{{ gamesInRoundDate.length }}</div>
                          <div
                            role="button"
                            class="arrow"
                            :class="{ 'btn-disabled': isNextDisabled }"
                            @click="onClickChangeGame('next')"
                          >
                            <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn-next-grey.svg" alt="next" />
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <CalendarMatch
                        v-for="(game, i) in gamesInRoundDate"
                        :key="i + '-' + game.game_id"
                        :game="game"
                        :color="headerStyles.color2"
                        :background="headerStyles.background"
                        :backgroundLive="headerStyles.backgroundLive"
                        :team-left="game.home_team"
                        :predictions="predictions"
                        :team-right="game.visiting_team"
                        :time="game.schedule.substring(0, 5)"
                        :date="new Date(game.date)"
                        :is-game-live="!!game.is_live"
                        :game-status="game.game_status"
                        :score="game.score"
                        :percentages="getPercentages(game)"
                        :home-goals="getGoalsStats(game, 'home')"
                        :visiting-goals="getGoalsStats(game, 'visiting')"
                        :containerWidth="gamesContainerWidth"
                        :is-cup="isCup"
                        @action="onGameClicked(game)"
                      />
                    </template>
                  </div>
                </div>
                <div class="button-more">
                  <div v-if="isShortVersion" class="button" @click="clickAreAllVisible">
                    Ver resto de la jornada
                  </div>
                </div>

                <div class="footer">
                  <div class="footer__logo">
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/logo_citec@2x.png" />
                  </div>
                  <div class="v-separator" />
                  <div class="footer__logo">
                    <img src="https://golstatsimages.blob.core.windows.net/todoelfut/logo_golstats@2x.png" />
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                :class="
                  type === 'only'
                    ? 'calendar-item-skeleton-component'
                    : type === 'onlycomponent'
                    ? 'calendar-item-skeleton-only'
                    : 'calendar-item-skeleton'
                "
              ></div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { connectSocket } from '@/utils/socketConnection';
import { BCarousel, BCarouselItem } from 'buefy/dist/esm/carousel';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { ceilMod } from '@/utils/maths.js';
import CalendarMatch from '@/components/ActiveTime/ActiveTimeCalendarMatch';
import CustomHeader from '@/components/Elements/CustomizableHeader';
import axios from 'axios';

// import { clickBtnPartido } from '@/utils/analytics';

import { regularLeague, cup, cupLegacy } from '@/utils/play-off-abbreviations';

export default {
  name: 'ActiveTimeCalendarComponent',
  components: {
    BCarousel,
    BCarouselItem,
    CalendarMatch,
    CustomHeader,
  },
  props: {
    id: {
      type: String,
      default: 'lc',
    },
    type: {
      type: String,
      default: 'only',
    },
    predictions: {
      type: Boolean,
      default: true,
    },
    custom: {
      type: Object,
      default: null,
    },
    /**
     * Seasons objects to fetch games
     * {Array<{id: number, type: number}>} seasons
     */
    seasons: {
      type: Array,
      default: () => [],
    },
    /**
     * Indicates if must await for the seasons prop, or not to get games schedule,
     * if not, tournaments will be fetched to get the seasons
     * {boolean} awaitForSeasons
     */
    awaitForSeasons: {
      type: Boolean,
      default: true,
    },
    gsData: {
      type: [Object, null],
      default: null,
    },
    isSecondRow: {
      type: Boolean,
      default: false,
    },
    isCup: {
      type: Boolean,
      default: false,
    },
    isCupLegacy: {
      type: Boolean,
      default: false,
    },
    isShortVersion: {
      type: Boolean,
      default: true,
    },
    preSelectedRound: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingFlag: true,
      roundSelectedStyle: {
        'background-color': '#CBEE6E',
      },
      fullTournamentSchedule: {},
      selectedRound: '1',
      gamesContainerWidth: 0,
      tournamentsUrl: 'https://17zyhpyc7c.execute-api.us-west-2.amazonaws.com/prod/tournaments',
      gamesUrl: 'https://qyyibs1w0d.execute-api.us-west-2.amazonaws.com/prod/calendar/gamesBySeason?',
      // gamesUrl: 'https://kkd48smit2.execute-api.us-west-2.amazonaws.com/qa/calendar/gamesBySeason?',
      lastSeasonsIds: [],
      showComplete: false,
      allEntries: [],
      areAllVisible: true,
      userTeamGames: [],
      isLiveGameFlag: false,
      selectedGameIndex: 0,
      selectedRoundKeyIndex: 0,
      carouselAction: null,
      areNewSeasons: false,
      roundScheduleContainer: null,
      nextGamesRoundsDesktop: null,
      intersectionObserverDesktop: null,
      observerEntriesDesktop: new Map(),
      calendarResizeObserver: null,
    };
  },
  watch: {
    fullTournamentSchedule() {
      var isLiveNum = 0;
      for (let [k, v] of Object.entries(this.fullTournamentSchedule)) {
        for (let [e, x] of Object.entries(v)) {
          for (let index = 0; index < x.games.length; index++) {
            if (x.games[index].is_live == 1) {
              isLiveNum += 1;
            }
          }
        }
      }
      if (isLiveNum > 0) {
        this.isLiveGameFlag = true;
        this.loopLive(true);
      } else {
        this.isLiveGameFlag = false;
        this.loopLive(false);
      }
    },
    seasons: {
      immediate: true,
      handler: function(newValue) {
        if (newValue && newValue.length) {
          this.selectedGameIndex = 0;
          this.areNewSeasons = true;
          this.lastSeasonsIds = newValue.map(season => season.id);
          this.createFullTournamentScheme(newValue, true);
        }
      },
    },
    selectedRound() {
      if (!this.roundScheduleContainer) {
        this.roundScheduleContainer = document.querySelector('.round-schedule-container');
      } else {
        this.roundScheduleContainer.scrollTop = 0;
      }
    },
    /**
     * {string} newValue - round name displayed
     */
    closestRound(newValue) {
      if (this.preSelectedRound) {
        this.selectedGameIndex = 0;
        this.selectedRound = this.preSelectedRound;
      } else {
        this.selectedRound = newValue;
      }
    },
    preSelectedRound(newValue) {
      this.selectedGameIndex = 0;
      this.selectedRound = newValue;
    },
    getPremiumAccount(value) {
      if (this.getPremiumAccount && value) connectSocket();
    },
    windowWidth() {
      this.checkHiddenSelectedRound();
    },
    loadingFlag: {
      immediate: true,
      handler(newValue) {
        if (!newValue) {
          setTimeout(() => {
            this.setUpResizeObserver();
          }, 100);
        }
      },
    },
    gamesInRoundDate(newValue) {
      this.selectedGameIndex = 0;
      if (newValue && newValue.length) {
        setTimeout(
          () => {
            if (this.areNewSeasons) {
              this.areNewSeasons = false;
            }
            if (this.getOpened) {
              if (this.carouselAction) {
                if (this.carouselAction === 'next') {
                  this.selectedGameIndex = 0;
                } else {
                  this.selectedGameIndex = newValue.length - 1;
                }
              } else {
                let userTeamGameIndex = newValue.findIndex(
                  game =>
                    this.gsData &&
                    (game.home_team.team_id === this.gsData.teamId ||
                      game.visiting_team.team_id === this.gsData.teamId),
                );
                if (userTeamGameIndex !== -1) {
                  this.selectedGameIndex = userTeamGameIndex;
                } else {
                  let selectedGameIndexAux = -1;
                  const nowMillis = new Date().getTime();
                  let diffMillisAbs = null;
                  let previousGame = null;
                  let i = 0;
                  for (const game of newValue) {
                    if (diffMillisAbs === null) {
                      diffMillisAbs = Math.abs(nowMillis - game.dateTimeMillis);
                      previousGame = game;
                    } else if (game.is_live) {
                      selectedGameIndexAux = i;
                      break;
                    } else {
                      const diffMillisAbsAux = nowMillis - game.dateTimeMillis;
                      if (Math.abs(diffMillisAbsAux) <= diffMillisAbs) {
                        diffMillisAbs = diffMillisAbsAux;
                        previousGame = game;
                      } else {
                        if (previousGame.game_status === 4) {
                          selectedGameIndexAux = i - 1;
                          break;
                        } else if (game.game_status === 4) {
                          selectedGameIndexAux = i;
                          break;
                        }
                      }
                    }
                    i++;
                  }
                  if (selectedGameIndexAux === -1) {
                    if (i > 0) {
                      this.selectedGameIndex = i - 1;
                    } else {
                      this.selectedGameIndex = i;
                    }
                  } else {
                    this.selectedGameIndex = selectedGameIndexAux;
                  }
                }
              }
            } else {
              this.selectedGameIndex = 0;
            }
          },
          this.areNewSeasons ? 2500 : 200,
        );
      }
    },
  },
  computed: {
    ...mapState(['windowWidth']),
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'getIsGolstats', 'getOpened']),

    isNextDisabled() {
      return this.gamesInRoundDate.length < 2;
    },
    isBackDisabled() {
      return this.gamesInRoundDate.length < 2;
    },
    headerIcon() {
      if (this.$route.query.logo) {
        return this.$route.query.logo;
      } else if (this.custom != null && Object.keys(this.custom).length) {
        return this.custom.logo;
      }
      return 'https://golstatsimages.blob.core.windows.net/content/escudo_golstats.png';
    },
    headerStyles() {
      if (this.custom != null) {
        if (Object.keys(this.custom).length) {
          return {
            color2: this.custom.headerColor2,
            color: this.custom.headerColor,
            background: this.custom.headerBackground,
            borderColor: this.custom.headerBorderColor,
            backgroundLive: this.custom.header2Background,
          };
        } else {
          return {
            color: this.$route.query.color || '#cbee6a',
            background: this.$route.query.background || '#132839',
          };
        }
      } else {
        return {
          color: this.$route.query.color || '#cbee6a',
          background: this.$route.query.background || '#132839',
          borderColor: this.$route.query.borderColor || '#cbee6a',
        };
      }
    },
    colorItemScroll() {
      if (this.custom != null) {
        if (Object.keys(this.custom).length) {
          return {
            background: '#CBEE6E',
          };
        } else {
          return {
            background: '#CBEE6E',
          };
        }
      } else {
        return {
          background: '#CBEE6E',
        };
      }
    },
    closestRound() {
      return this.userTeamGames && this.userTeamGames.length
        ? this.getUserTeamClosestRound(this.fullTournamentSchedule)
        : this.getNormalClosestRound(this.fullTournamentSchedule);
    },
    gamesInRoundDate() {
      let data = [];
      const tournamentScheduleSelected = this.fullTournamentSchedule[this.selectedRound];
      if (!tournamentScheduleSelected) {
        return [];
      }
      tournamentScheduleSelected.forEach(roundDate => {
        data.push(...roundDate.games.filter(game => game.home_team && game.visiting_team));
      });
      return data;
    },
    gridTemplateColumns() {
      if (this.gamesContainerWidth > 0) {
        const templateColumns =
          this.isShortVersion || this.gamesContainerWidth < 581
            ? '1fr'
            : this.gamesContainerWidth < 831
            ? 'repeat(2, 1fr)'
            : this.gamesContainerWidth < 941
            ? 'repeat(3, 1fr)'
            : 'repeat(4, 1fr)';
        return { 'grid-template-columns': templateColumns, 'row-gap': this.isShortVersion ? '2px' : '10px' };
      }
      return {};
    },
  },
  methods: {
    ...mapMutations('loginGeneral', ['setOpened']),
    ...mapMutations(['setIsSectionLoading']),
    ...mapMutations('nextGeneral', ['prepareCleanAllStatistics']),
    ...mapMutations('leagueGeneral', ['updateSelectedRound']),
    ...mapActions('routes', ['goToGame']),
    loopLive() {
      if (this.isLiveGameFlag) {
        setTimeout(() => {
          this.createFullTournamentScheme(this.seasons, 'socket');
          this.loopLive(this.isLiveGameFlag);
        }, 60000);
      }
    },
    /**
     * @author Alejandro
     * @param {Array<{id: Number, type: Number}>} seasons - Seasons objects
     * id: season id
     * type: season type, values can be 0 for regular and 1 for playoffs
     * @param {boolean} applySeasonsValidation
     * @return {Promise<void>}
     */
    async createFullTournamentScheme(seasons, applySeasonsValidation) {
      try {
        connectSocket();
        await this.prepareCleanAllStatistics();
        const { seasonsAndGames, seasonsAndTeams } = await this.fetchSeasonsGamesAndTeams(
          seasons.map(season => {
            return season.id;
          }),
          3,
        );
        if (applySeasonsValidation === 'socket') {
          for (let [k, v] of Object.entries(this.fullTournamentSchedule)) {
            for (let [e, x] of Object.entries(v)) {
              for (let index = 0; index < x.games.length; index++) {
                var indexGame = seasonsAndGames[0].games.findIndex(game => game.game_id == x.games[index].game_id);
                x.games[index].time_active = seasonsAndGames[0].games[indexGame].time_active;
              }
            }
          }
        } else {
          this.fullTournamentSchedule = {};
          this.userTeamGames = [];
          let regularSeasonId = 0;

          if (applySeasonsValidation && this.areSeasonsDifferent(seasonsAndGames)) return;
          seasonsAndGames.forEach(seasonAndGames => {
            const { type } = seasons.find(season => season.id === seasonAndGames.season_id);
            seasonAndGames.type = type;
            seasonAndGames.games.forEach(game => {
              game.season_id = seasonAndGames.season_id;
            });
            if (type === 0) {
              regularSeasonId = seasonAndGames.season_id;
            }
          });
          const tournamentGames = {
            seasonsGames: seasonsAndGames,
          };
          const { teams } = seasonsAndTeams.find(seasonAndTeams => seasonAndTeams.season_id === regularSeasonId);
          const seasonsSchedules =
            tournamentGames && tournamentGames.seasonsGames
              ? tournamentGames.seasonsGames.map(seasonAndGames => {
                  const schedule = seasonAndGames.games.reduce((accumulator, game) => {
                    const gameTmp = { ...game };
                    gameTmp.dateTimeMillis = new Date(gameTmp.date_time_utc).valueOf();
                    gameTmp.home_team = teams.find(team => team.team_id === game.home_team);
                    gameTmp.visiting_team = teams.find(team => team.team_id === game.visiting_team);
                    if (!accumulator[game.matchday_abbreviation]) {
                      accumulator[game.matchday_abbreviation] = {
                        [game.game_status === 3 ? 'canceled' : game.date]: [gameTmp],
                      };
                    } else if (
                      !accumulator[game.matchday_abbreviation][game.game_status === 3 ? 'canceled' : game.date]
                    ) {
                      accumulator[game.matchday_abbreviation][game.game_status === 3 ? 'canceled' : game.date] = [
                        gameTmp,
                      ];
                    } else {
                      accumulator[game.matchday_abbreviation][game.game_status === 3 ? 'canceled' : game.date].push(
                        gameTmp,
                      );
                    }
                    if (
                      this.gsData &&
                      this.gsData.teamId &&
                      gameTmp.game_status === 4 &&
                      (gameTmp.home_team.team_id === this.gsData.teamId ||
                        gameTmp.visiting_team.team_id === this.gsData.teamId)
                    ) {
                      this.userTeamGames.push(gameTmp);
                    }
                    return accumulator;
                  }, {});
                  this.userTeamGames.sort((a, b) => a.dateTimeMillis - b.dateTimeMillis);
                  for (let [k, v] of Object.entries(schedule)) {
                    schedule[k] = Object.entries(v).map(([k2, v2]) => {
                      return {
                        date: k2,
                        games: v2.sort((a, b) => a.dateTimeMillis - b.dateTimeMillis),
                      };
                    });
                    schedule[k].sort((a, b) => {
                      return a.date < b.date ? -1 : a.date > b.date ? 1 : 0;
                    });
                  }
                  return {
                    type: seasonAndGames.type,
                    weight: seasonAndGames.type === 0 ? 0 : seasonAndGames.type === 2 ? 1 : 2,
                    schedule,
                  };
                })
              : [];
          seasonsSchedules.sort((a, b) => a.weight - b.weight);
          this.fullTournamentSchedule = seasonsSchedules.reduce((accumulator, seasonSchedule) => {
            for (const [k, v] of Object.entries(seasonSchedule.schedule)) {
              if (seasonSchedule.type === 0) {
                if (this.isCup) {
                  const roundNumberString = k.replace('M', '');
                  const defaultName = `Jornada ${roundNumberString}`;
                  if (this.isCupLegacy) {
                    accumulator[cupLegacy[roundNumberString] || defaultName] = v;
                  } else {
                    accumulator[cup[k] || defaultName] = v;
                  }
                } else {
                  accumulator[Number(k.replace('M', '')).toString()] = v;
                }
              } else if (seasonSchedule.type === 2) {
                if (['PI1', 'PI2'].includes(k)) {
                  accumulator[k] = v;
                } else {
                  accumulator[`R${Number(k.replace('PO', ''))}`] = v;
                }
              } else if (seasonSchedule.type === 1) {
                accumulator[regularLeague[k]] = v;
              }
            }
            return accumulator;
          }, {});
          setTimeout(() => {
            this.setUpIntersectionObserver();
          }, 500);
        }
      } catch (e) {
        throw new Error(e);
      } finally {
        this.loadingFlag = false;
      }
    },
    clickAreAllVisible() {
      this.$emit('open', this.selectedRound);
    },
    clickAreAllInVisible() {
      this.setOpened(true);
      this.areAllVisible = true;
    },
    areSeasonsDifferent(seasonAndGames) {
      for (const season of seasonAndGames) {
        if (!this.lastSeasonsIds.includes(season.season_id)) {
          return true;
        }
      }
      return false;
    },
    setUpResizeObserver() {
      if (window.ResizeObserver) {
        this.calendarResizeObserver = new ResizeObserver(() => {
          this.gamesContainerWidth = this.$refs.gamesContainer.clientWidth;
        });
        this.calendarResizeObserver.observe(this.$refs.gamesContainer);
      } else {
        throw new Error('Resize observer not supported!');
      }
    },
    /**
     * @author Alejandro Martinez
     * @param {number} retries
     * @return {Promise<any|undefined>}
     */
    async fetchTournaments(retries) {
      try {
        const { data } = await axios.get(this.tournamentsUrl);
        return data;
      } catch (e) {
        if (retries > 0) {
          return this.fetchTournaments(retries - 1);
        }
        throw new Error(e);
      }
    },
    /**
     * @author Alejandro Martinez
     * @param {Array<number>} seasons - seasons ids
     * @param {number} retries - Times to retry the request
     * @param {String} createdUrl - Url to make the request
     * @return {Promise<{seasonsAndGames: *, seasonsAndTeams: *}|*|undefined>}
     */
    async fetchSeasonsGamesAndTeams(seasons, retries, createdUrl = '') {
      let gamesUrl = createdUrl;
      try {
        if (!gamesUrl) {
          gamesUrl = this.gamesUrl;
          seasons.forEach((seasonId, index) => {
            const prefix = index === 0 ? '' : '&';
            gamesUrl += `${prefix}seasons=${seasonId}`;
          });
        }
        const {
          data: { data, teams },
        } = await axios.get(gamesUrl);
        return { seasonsAndGames: data, seasonsAndTeams: teams };
      } catch (e) {
        if (retries > 0) {
          return this.fetchSeasonsGamesAndTeams(seasons, retries - 1, gamesUrl);
        }
        throw new Error(e);
      }
    },
    setUpIntersectionObserver() {
      this.nextGamesRoundsDesktop = document.getElementById(`${this.id}RC`);
      const scrollItems = document.querySelectorAll(
        `.round-item-desktop.${this.id}${this.isShortVersion ? '-short-version' : ''}`,
      );
      if (scrollItems.length === 0) return;
      // Creation of an intersection observer
      // see https://developer.mozilla.org/es/docs/Web/API/Intersection_Observer_API
      this.observerEntriesDesktop.clear();
      this.intersectionObserverDesktop = new IntersectionObserver(
        entries => {
          if (this.allEntries.length === 0) {
            this.allEntries = entries;
            this.checkHiddenSelectedRound();
          }
          entries.forEach(entry => {
            this.observerEntriesDesktop.set(entry.target.id, entry);
          });
        },
        {
          root: this.nextGamesRoundsDesktop,
          threshold: 1,
        },
      );
      scrollItems.forEach(scrollItem => {
        this.intersectionObserverDesktop.observe(scrollItem);
      });
    },
    checkHiddenSelectedRound() {
      const entry = this.allEntries.find(entry => entry.target.id === `si${this.selectedRound}${this.id}`);
      if (entry && this.$refs.roundsContainer) {
        const containerRect = this.$refs.roundsContainer.getBoundingClientRect();
        const divRect = entry.target.getBoundingClientRect();
        if (containerRect.width < divRect.x) {
          this.$refs.roundsContainer.scrollLeft = divRect.x - entry.rootBounds.x;
        }
      }
    },
    getNormalClosestRound(tournamentSchedule) {
      const gameDuration = 110 * 60 * 1000;
      const roundsAndEndOfLastGame = Object.entries(
        Object.entries(tournamentSchedule).reduce((accumulator, [k, v]) => {
          accumulator[k] = [];
          v.forEach(day => {
            day.games.forEach(game => {
              const endOfGame = new Date(game.date_time_utc).getTime() + gameDuration;
              accumulator[k].push(endOfGame);
            });
          });
          return accumulator;
        }, {}),
      );
      if (!roundsAndEndOfLastGame.length) {
        return '1';
      }
      const currentTime = new Date().getTime();
      const closestRound = roundsAndEndOfLastGame.reduce(
        (accumulator, [k, v]) => {
          let timeDifferenceGlobal = null;
          v.forEach(endOfGame => {
            const timeDifference = endOfGame - currentTime;
            if (timeDifference >= 0 && (timeDifferenceGlobal === null || timeDifference < timeDifferenceGlobal)) {
              timeDifferenceGlobal = timeDifference;
            }
          });
          if (
            timeDifferenceGlobal &&
            (accumulator.shortestTime === null || timeDifferenceGlobal < accumulator.shortestTime)
          ) {
            accumulator.round = k;
            accumulator.shortestTime = timeDifferenceGlobal;
          }
          return accumulator;
        },
        { round: '', shortestTime: null },
      );

      return closestRound.shortestTime !== null
        ? closestRound.round
        : roundsAndEndOfLastGame[roundsAndEndOfLastGame.length - 1][0];
    },
    getUserTeamClosestRound(tournamentSchedule) {
      let round = 1;
      if (this.userTeamGames.length) {
        const closestUserTeamGame = this.userTeamGames[0];
        for (const [round, value] of Object.entries(tournamentSchedule)) {
          for (const day of value) {
            const scheduleGame = day.games.find(game => game.game_id === closestUserTeamGame.game_id);
            if (scheduleGame) {
              return round;
            }
          }
        }
      }
      return round;
    },
    onClickScrollLeft() {
      let entryAux = null;
      for (let entry of this.observerEntriesDesktop.values()) {
        // When this conditional compares to true, means that current entry
        // is fully visible after another that is not fully visible, so the partially visible
        // entry's x position is where we need scroll to
        if (entryAux && entryAux.intersectionRatio < 1 && entry.intersectionRatio === 1) {
          this.nextGamesRoundsDesktop.scrollTo({
            // top: 0,
            left: this.nextGamesRoundsDesktop.scrollLeft - entry.rootBounds.width,
            behavior: 'smooth',
          });
          break;
        }
        entryAux = entry;
      }
    },
    onClickScrollRight() {
      let startRatio = 0;
      for (let entry of this.observerEntriesDesktop.values()) {
        // When this conditional compares to true, means that current entry
        // is not fully visible after another that is visible, so this entry's
        // x position is where we need scroll to
        if (startRatio === 1 && entry.intersectionRatio < 1) {
          this.nextGamesRoundsDesktop.scrollTo({
            left: this.nextGamesRoundsDesktop.scrollLeft + entry.rootBounds.width,
            behavior: 'smooth',
          });
          break;
        }
        startRatio = entry.intersectionRatio;
      }
    },
    onGameClicked(game) {
      this.$emit('action', game);
    },
    onClickChangeGame(action) {
      this.carouselAction = action;
      if (action === 'next' && !this.isNextDisabled) {
        if (this.selectedGameIndex === this.gamesInRoundDate.length - 1) {
          this.selectedGameIndex = 0;
        } else {
          this.selectedGameIndex++;
        }
      } else if (!this.isBackDisabled) {
        if (this.selectedGameIndex === 0) {
          this.selectedGameIndex = this.gamesInRoundDate.length - 1;
        } else {
          this.selectedGameIndex--;
        }
      }
    },
    onChangeCarousel(value) {
      const diff = value - this.selectedGameIndex;
      if (
        value === 0 &&
        this.selectedGameIndex > value &&
        this.selectedGameIndex === this.gamesInRoundDate.length - 1
      ) {
        this.onClickChangeGame('next');
      } else if (
        value === this.gamesInRoundDate.length - 1 &&
        this.selectedGameIndex < value &&
        this.selectedGameIndex === 0
      ) {
        this.onClickChangeGame('back');
      } else if (diff === 1) {
        this.onClickChangeGame('next');
      } else if (diff === -1) {
        this.onClickChangeGame('back');
      }
    },
    onClickRound(round) {
      this.selectedGameIndex = 0;
      this.carouselAction = null;
      this.selectedRound = round;
    },
    getPercentages(game) {
      return [game.home_team_probability, game.draw_probability, game.visiting_team_probability];
    },
    getGoalsStats(game, teamType) {
      return [game[`${teamType}_team_goals`], ceilMod(game[`${teamType}_team_xg`], 2)];
    },
    getProbabilities(game) {
      if (game.draw_probability || game.home_team_probability || game.visiting_team_probability) {
        return {
          drawProbability: game.draw_probability,
          homeTeamProbability: game.home_team_probability,
          awayTeamProbability: game.visiting_team_probability,
        };
      }
      return null;
    },
  },
  async created() {
    try {
      if (!this.awaitForSeasons) {
        const tournaments = await this.fetchTournaments(3);
        const mxLeague = tournaments.find(tournament => tournament._id === 1);
        const regularSeason = mxLeague.seasons[0];
        const seasons = [{ id: regularSeason.id, type: regularSeason.type }];
        if (mxLeague && mxLeague.tournament) {
          this.$emit('tournament-selected', mxLeague.tournament);
        }
        if (regularSeason.related_seasons && regularSeason.related_seasons.length) {
          seasons.push(
            ...regularSeason.related_seasons.map(relatedSeason => ({ id: relatedSeason.id, type: relatedSeason.type })),
          );
        }
        await this.createFullTournamentScheme(seasons, false);
      }
    } catch (e) {
      throw new Error(e);
    }
  },
  beforeDestroy() {
    this.roundScheduleContainer = null;
    this.nextGamesRoundsDesktop = null;
    this.intersectionObserverDesktop = null;
    this.observerEntriesDesktop = new Map();
    if (this.calendarResizeObserver) {
      this.calendarResizeObserver.unobserve(this.$refs.gamesContainer);
    }
  },
};
</script>

<style lang="scss">
$game-border-radius: 9px;
.games__container {
  width: 100%;
  display: grid;
  grid-column-gap: 8px;
  grid-row-gap: 8px;
  padding: 5px;
  height: fit-content;
  background-color: white;

  &.fallback {
    @media screen and (max-width: 1080px) {
      grid-template-columns: 1fr;
    }
    @media screen and (max-width: 940px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width: 680px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
.calendar-item-skeleton {
  border-radius: 3px;
  width: 100%;
  height: 666px;
  min-height: 666px;
  max-height: 666px;
  @media screen and (max-width: 1080px) {
    min-height: 431.1px;
    max-height: 431.1px;
  }
  background-color: #f5f5f5;
  box-shadow: 0 1px 2px 0 rgba(33, 33, 33, 0.05);
  box-sizing: content-box;
  display: flex;
  position: relative;
  overflow: hidden;
  font-family: 'Avenir-Regular';
}
.calendar-item-skeleton-only {
  border-radius: 3px;
  width: 100%;
  height: 460px;
  min-height: 460px;
  max-height: 460px;
  @media screen and (max-width: 1080px) {
    min-height: 431.1px;
    max-height: 431.1px;
  }
  background-color: #f5f5f5;
  box-shadow: 0 1px 2px 0 rgba(33, 33, 33, 0.05);
  box-sizing: content-box;
  display: flex;
  position: relative;
  overflow: hidden;
  font-family: 'Avenir-Regular';
}
.calendar-item-skeleton-component {
  border-radius: 3px;
  width: 100%;
  height: 460px;
  min-height: 460px;
  max-height: 460px;
  @media screen and (max-width: 1080px) {
    min-height: 431.1px;
    max-height: 431.1px;
  }
  background-color: #f5f5f5;
  box-shadow: 0 1px 2px 0 rgba(33, 33, 33, 0.05);
  box-sizing: content-box;
  display: flex;
  position: relative;
  overflow: hidden;
  font-family: 'Avenir-Regular';
}
.calendar-item-skeleton::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(to right, transparent 0%, #e8e8e8 50%, transparent 100%);
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}

.is-fullheight-with-navbar-and-footer,
.is-fullheight-with-navbar-and-footer-mobile {
  height: calc(100% - 1px);
}

.calendar {
  background-color: white;
  margin: 0 0px;

  .bg-gray {
    background-color: #f7faf9;
  }

  &__header {
    width: 100%;
    min-width: 285px;
    max-width: 1268px;
    margin: 0 auto;
  }

  &__footer {
    grid-area: footer;
    width: 100%;
    height: 2rem;
  }

  &__divider {
    background: lightgrey;
    height: 60%;
    width: 1px;
  }

  &__btn {
    cursor: pointer;
    width: 280px;
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Circular-Std-Medium;
    border-radius: 14.3px;
    border: solid 5.5px rgba($color: #afbfc7, $alpha: 0.3);
    font-size: 21px;
    margin: 20px auto;
    height: 50px;
    white-space: nowrap;
  }

  &__content {
    .main-container {
      display: flex;
      justify-content: center;
      min-width: 285px;
    }

    .next-games-container-desktop {
      width: 100%;
      border: 1px solid #c0c0c0;
      display: flex;
      flex-direction: column;
      align-items: center;

      & .journey {
        color: #132839 !important;
        text-align: center;
      }
    }

    .next-games-grid-component {
      height: 100%;
      max-width: 100%;
      min-width: 100%;
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-template-areas:
        'journey paginator paginator paginator paginator paginator'
        'content content content content content content'
        'footer footer footer footer footer footer';
      grid-template-rows: min-content auto;

      &.is-short-version {
        grid-template-areas:
          'journey paginator paginator paginator paginator paginator'
          'content content content content content content'
          'full full full full full full'
          'footer footer footer footer footer footer';
      }

      & .journey {
        grid-area: journey;
        height: 40px;
      }
      & .rounds-controller {
        grid-area: paginator;
        display: flex;
        height: 40px;
        width: 100%;
      }
      & .round-schedule {
        margin: 0.2rem 0.3rem;
      }
      & .round-schedule-container {
        grid-area: content;
        //display: flex;
        //justify-content: center;
        width: 100%;
        margin: 0 auto;
        overflow: auto;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    .next-games-grid-component-only {
      height: 100%;
      max-width: 100%;
      height: 443px;
      min-height: 445px;
      max-height: 445px;
      display: grid;
      @media screen and (max-width: 699px) {
        height: 100%;
        max-height: none;
        min-height: fit-content;
      }
      grid-template-columns: repeat(6, 1fr);
      grid-auto-rows: minmax(40px, auto);
      grid-template-areas:
        'journey paginator paginator paginator paginator paginator'
        'content content content content content content'
        'footer footer footer footer footer footer';
      grid-template-rows: min-content auto;

      & .journey {
        grid-area: journey;
        height: 40px;
      }
      & .rounds-controller {
        grid-area: paginator;
        display: flex;
        height: 40px;
        width: 100%;
      }
      & .round-schedule {
        margin: 0.2rem 0.3rem;
      }
      & .round-schedule-container {
        grid-area: content;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        min-height: 369.1px;
        @media screen and (max-width: 699px) {
          height: 100%;
          max-height: none;
          min-height: fit-content;
        }
        width: 100%;
        margin: 0 auto;
        max-height: calc(80vh - 2rem);
        overflow: auto;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    .next-games-grid {
      height: 100%;
      max-width: 100%;
      height: 730px;
      min-height: 730px;
      max-height: 730px;
      @media screen and (max-width: 1080px) {
        min-height: 464.1px;
        max-height: 464.1px;
      }
      @media screen and (max-width: 699px) {
        height: 100%;
        max-height: none;
        min-height: fit-content;
      }
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-auto-rows: minmax(40px, auto);
      grid-template-areas:
        'journey paginator paginator paginator paginator paginator'
        'content content content content content content'
        'footer footer footer footer footer footer';
      grid-template-rows: min-content auto;

      & .journey {
        grid-area: journey;
        height: 40px;
      }
      & .rounds-controller {
        grid-area: paginator;
        display: flex;
        height: 40px;
        width: 100%;
      }
      & .round-schedule {
        margin: 0.2rem 0.3rem;
      }
      & .round-schedule-container {
        grid-area: content;
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        min-height: 614.1px;
        @media screen and (max-width: 1080px) {
          min-height: 389.1px;
        }
        @media screen and (max-width: 699px) {
          height: 100%;
          max-height: none;
          min-height: fit-content;
        }
        width: 100%;
        margin: 0 auto;
        max-height: calc(80vh - 2rem);
        overflow: auto;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */

        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    .rounds-scroll-button {
      height: 40px;
      width: 40px;
      padding-top: 10px;
      flex-shrink: 0;
      text-align: center;
      background-color: #edf4f9;

      &.left-button > img {
        // Chrome
        -webkit-transform: rotate(180deg);
        // Firefox
        -moz-transform: rotate(180deg);
        // Opera
        -o-transform: rotate(180deg);
        // W3C compliant browsers
        transform: rotate(180deg);
      }

      &:active {
        box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.25);
      }
    }

    .rounds-scroll-button:hover {
      background-color: #dbdbdb;
    }

    .next-games-rounds-desktop {
      min-width: 125px;
      width: 100%;
      flex-shrink: 1;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      overflow-x: auto;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
      /* Hide scroll bar in firefox*/
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .round-item-desktop {
      width: fit-content;
      height: 29px;
      margin: 0 6px;
      padding: 0 0.6em;
      border-radius: 5px;
      font-size: 13px;
      vertical-align: middle;
      line-height: 32px;
      flex-shrink: 0;
      text-align: center;
      color: #132839 !important;
      &:hover {
        background-color: #f7faf9;
      }
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.footer {
  margin: 1em 1em 0.8em;
  grid-area: footer;
  display: grid;
  grid-template-columns: 1fr 36px 1fr;
  height: fit-content;
  padding: 0;
  background-color: white;

  & > div {
    justify-self: center;
    align-self: center;

    &.footer__logo {
      &:first-child {
        justify-self: flex-end;
      }

      &:last-child {
        justify-self: flex-start;
      }
    }

    & > img {
      max-width: 112px;
    }
  }

  &__citec {
  }
}
.v-separator {
  border-left: dotted 0.5px #d2d2d2;
  height: 50%;
}
.button-more {
  grid-area: full;
  margin: 0 0.5em;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  & > div.button {
    width: 100%;
    font-family: Avenir-Medium, sans-serif;
    font-size: 0.875rem;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 30px;
    letter-spacing: -0.28px;
    text-align: center;
    color: #000;
    border-radius: 8px;
    border: solid 1px #132839;
    cursor: pointer;
  }
}
.games-carousel {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__arrows {
    margin-top: 1em;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;

    & > .indicator {
      margin: 0 30px;
      font-family: Avenir-Medium, sans-serif;
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: -0.28px;
      text-align: center;
      color: #000;
    }

    & > .arrow {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      background-color: #f6faf9;
      cursor: pointer;
      padding: 6px 24px;

      & > img {
        height: 12px;
        width: 7.4px;
      }
    }
  }
}
.left-button > img {
  // Chrome
  -webkit-transform: rotate(180deg);
  // Firefox
  -moz-transform: rotate(180deg);
  // Opera
  -o-transform: rotate(180deg);
  // W3C compliant browsers
  transform: rotate(180deg);
}
.btn-disabled {
  cursor: default !important;
  opacity: 0.3;
}
</style>
<style>
.calendar div.carousel {
  width: 100% !important;
}
</style>
